import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  CreateWinePreferenceDto,
  GetPreferenceResponse,
  PatchPreference,
  PatchPreferenceOtherFees,
  PatchWinePreferenceIdResponse,
} from "../types/api/api-types";
import { toast } from "react-toastify";
import { axiosApi } from "./axios";

export const getPreference = async () => {
  return axiosApi.get<GetPreferenceResponse>("/preference").then((res) => res.data);
};

export const useGetPreference = () => {
  return useQuery({
    queryKey: ["preference"],
    queryFn: () => getPreference(),
  });
};

const patchPreference = async (data: PatchPreference) => {
  return axiosApi.patch(`/preference`, data);
};

export const usePatchPreference = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchPreference,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["preference"] });
    },
  });
};

const patchPreferenceOtherFees = async (data: PatchPreferenceOtherFees) => {
  return axiosApi.patch(`/preference/otherFees`, data);
};

export const usePatchPreferenceOtherFees = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchPreferenceOtherFees,
    onSuccess: () => {
      toast.success("Les frais annexes ont bien été mis à jour");
      queryClient.invalidateQueries({ queryKey: ["preference"] });
    },
    onError: () => {
      toast.error("Une erreur est survenue lors de la mise à jour");
    },
  });
};

const createWinePreference = async (data: CreateWinePreferenceDto) => {
  return axiosApi.post(`/wine-preference`, data);
};

export const useCreateWinePreference = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createWinePreference,
    onSuccess: () => {
      toast.success("La préférence a bien été enregistrée");
      queryClient.invalidateQueries({ queryKey: ["preference"] });
    },
    onError: () => {
      toast.error("Une erreur est survenue lors de la création");
    },
  });
};

const updateWinePreference = async (data: PatchWinePreferenceIdResponse) => {
  return axiosApi.patch(`/wine-preference/` + data.id, data);
};

export const useUpdateWinePreference = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateWinePreference,
    onSuccess: () => {
      toast.success("La préférence a bien été enregistrée");
      queryClient.invalidateQueries({ queryKey: ["preference"] });
    },
    onError: () => {
      toast.error("Une erreur est survenue lors de la modification");
    },
  });
};

const deleteWinePreference = async (id: string) => {
  return axiosApi.delete(`/wine-preference/${id}`);
};

export const useDeleteWinePreference = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteWinePreference,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["preference"] });
      toast.success("La préférence a bien été supprimée");
    },
    onError: () => {
      toast.error("Une erreur est survenue lors de la suppression");
    },
  });
};
